//@ts-ignore
import { CircularProgress, Grid } from '@mui/material';
import css from './AiModal.module.css';

import { getDroppedOrSelectedFiles } from 'html5-file-selector';
import React, { useState } from 'react';
import Dropzone, { IInputProps, ILayoutProps } from 'react-dropzone-uploader';

import { Icons } from '../../../assets/SvgIcons';
import { ICTaskAttachment } from '../../../helper/Interfaces';

//@ts-ignore
interface CustomDropZoneProps {
  setAttachments: (files: File[], icon: any) => void;
  disabled?: boolean;
}

const AiCustomDropzone = (props: CustomDropZoneProps) => {
  const maxSize = 50000000;
  const { disabled, setAttachments } = props;
  const [initialFiles, setInitialFiles] = React.useState<ICTaskAttachment[]>(
    []
  );

  const [fileLoading, setFileLoading] = useState<boolean>(false);

  const Input = ({
    accept,
    onFiles,
    files,
    getFilesFromEvent,
  }: IInputProps) => {
    const text = files.length > 0 ? 'Add more files' : 'Choose files';

    return (
      <label>
        {fileLoading ? <CircularProgress size={20} color="inherit" /> : <></>}{' '}
        <div>
          <div
            className={css.EmptyMessageDocument}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <div className={[css.EmptyMessage].join(' ')}>
              <Icons.EmptyAiDocument />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 6,
                }}
              >
                <span style={{ fontWeight: 700 }}>Talk to your document</span>
                <span>
                  In order to talk to your document first upload a document.
                </span>
                <span>Click here to upload or drag it over here.</span>
              </div>
            </div>
          </div>
        </div>
        <input
          style={{ display: 'none' }}
          type="file"
          accept={text}
          multiple
          disabled={fileLoading || disabled}
          onChange={async e => {
            setFileLoading(true);
            const chosenFiles = await getFilesFromEvent(e);
            const src = chosenFiles[0].name?.split('.').pop() || '';
            setAttachments(chosenFiles, fileType(src));
            setFileLoading(false);

            // TODO: make your code work
          }}
        />
      </label>
    );
  };

  const getFilesFromEvent = async (e: any) => {
    const chosenFiles = await getDroppedOrSelectedFiles(e);
    return chosenFiles.map((f: any) => f.fileObject);
  };

  const fileType = (file: string) => {
    const opt = '20';
    if (
      file === 'xml' ||
      file === 'png' ||
      file === 'jpeg' ||
      file === 'jpg' ||
      file === 'svg'
    ) {
      return (
        <div>
          <Icons.Png height={opt} width={opt} />
        </div>
      );
    }
    if (file === 'pdf') {
      return (
        <div>
          <Icons.Pdf height={opt} width={opt} />
        </div>
      );
    }
    if (file === 'xls' || file === 'xlsx' || file === 'csv') {
      return (
        <div>
          <Icons.Xls height={opt} width={opt} />
        </div>
      );
    }
    if (file === 'doc' || file === 'docx') {
      return (
        <div>
          <Icons.Doc height={opt} width={opt} />
        </div>
      );
    }
    if (file === 'pptx' || file === 'pot' || file === 'pps' || file === 'ppa') {
      return (
        <div>
          <Icons.Pptx height={opt} width={opt} />
        </div>
      );
    }
    return (
      <div>
        <Icons.QuestionMark height={opt} width={opt} />
      </div>
    );
  };

  const openAttachment = async (attachment: ICTaskAttachment) => {
    let type = '';
  };

  const Preview = (attachmet: ICTaskAttachment) => {
    const src = attachmet.document.name?.split('.').pop() || '';
    return (
      <div key={attachmet.id}>
        <span onClick={() => openAttachment(attachmet)}>
          {fileType(src)}
          <div>{attachmet.document.name} </div>
        </span>
      </div>
    );
  };

  const fileDrop = async (e: any) => {
    e.preventDefault();
    setFileLoading(true);
    const chosenFiles = await getFilesFromEvent(e);
    const src = chosenFiles[0].name?.split('.').pop() || '';
    setAttachments(chosenFiles[0], fileType(src));
    setFileLoading(false);
  };

  const Layout = ({
    input,
    previews,
    submitButton,
    dropzoneProps,
    files,
    extra: { maxFiles },
  }: ILayoutProps) => {
    return (
      <div {...dropzoneProps} onDrop={fileDrop}>
        <div>{files.length < maxFiles && input}</div>

        {/*{files.length > 0 && submitButton}*/}
        <div style={{ marginTop: 15 }}>
          {<Grid container>{initialFiles?.map(item => Preview(item))}</Grid>}
          {initialFiles
            .map(i => parseInt(i.document.size))
            .reduce((acc: number, curr: number) => acc + curr, 0) > maxSize && (
            <div
              style={{
                fontStyle: 'italic',
                color: 'red',
                fontSize: '1.4vh',
              }}
            >
              Maximum File Size is 50 MB
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Dropzone
        LayoutComponent={Layout}
        InputComponent={Input}
        maxSizeBytes={maxSize}
        autoUpload={true}
        getFilesFromEvent={getFilesFromEvent}
        multiple
      />
    </>
  );
};

export default AiCustomDropzone;
